/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : cart-details-api.ts
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H352615
 *
 * @Date         : AUG 2, 2019
 *
 * @Version      : Version 1.0
 *
 * *By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : Integrated get Cart Details service (ASDS-909)
 * By            : Avanthi G (E860178)
 * On            : Sep 06, 2019
 * Description   : Sending Dymanic UserID for fetching mycart details service and add to cart service(ASDS-1173)
 *
 * By            : Deepthi B (E844276)
 * On            : Sep 23, 2019
 * Description   : Added delete aspire product api - ASDS-413
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 03 2019
 * Description   : ASDS-1964
 *
 * By            : H224423
 * On            : Dec 17 2019
 * Description   : UT Automation - API data changes
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Apr 06,2020
 * Description   : updated code as per ASDS-2432.
 *
 * By            : H422336
 * On            : Oct 9, 2020
 * Description   : ASDS - 3259 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3260 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct 13, 2020
 * Description   : ASDS - 3262, ASDS-3263 UI Enhancements for Phase - II
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 *
 * By            : H422337
 * On            : Nov, 19 2020
 * Description   : ASDS-4083 UI Enhancements for Phase-II  bug fix & Delete All  products from the cart
 *
 ******************************************************************************/

import { CheckoutServiceURL } from "../constants/checkout-constants";
import API from "./api";
import { handleError, handleResponse } from "./apiUtils";
import { ContractsDeleteI } from "../utils/checkout-interfaces";
import { logError } from "../../../utils/console-utility";

class CartDetails {
  static async getCartData(userId: string, soldTo: string): Promise<any> {
    // get saved cart products
    const response = await API.get(
      `${CheckoutServiceURL.GET_CART_DETAILS_URL}${userId}/carts?soldTo=${soldTo}`
    ).catch(error => {
      if (error.response && error.response.status === 401) {
        handleError(error);
      } else {
        logError('Error in fetching cart data', error);
      }
    });
    return response ? response.data : {};
  }

  static async deleteProduct(userId: string, cartSeq: number, prodSeq: number): Promise<any> {
    // delete selected product
    const response: any = await API.delete(`${CheckoutServiceURL.CART_URL}${userId}/carts/${cartSeq}/products/${prodSeq}`);
    return response.data;
  }

  static async deleteAllProduct(userId: string): Promise<any> {
    // delete  All  product
    const response: any = await API.delete(`${CheckoutServiceURL.CART_URL}${userId}/carts`);
    return response.data;
  }

  static async saveProductToCart(cartProduct: any, userId: string): Promise<any> {
    try {
        const response = await API.post(`${CheckoutServiceURL.CART_URL}${userId}/carts`, cartProduct);
        return response;
    } catch (error) {
        logError('save product failed', error);
        return null; 
    }
}

  static async editProductToCart(cartProduct: any, userId: string): Promise<any> {
    const response = await API.put(
      `${CheckoutServiceURL.CART_URL}${userId}/carts`,
      cartProduct
    ).catch(error => logError('save product failed', error));
    // not handling error, as it is a save event
    return response;
  }

  static async checkExpiredContracts(userId: string): Promise<ContractsDeleteI> {
    return await API.get(
      `${CheckoutServiceURL.CHECK_EXPIRED_CONTRACTS}/${userId}/expired-contracts`).then(handleResponse).catch(handleError);
  }
}

export default CartDetails;